import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-transversal-categories',
  templateUrl: './home-transversal-categories.component.html',
  styleUrls: ['./home-transversal-categories.component.scss']
})
export class HomeTransversalCategoriesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
